export function isNotEmptyString(arg: unknown): arg is string {
  return typeof arg === 'string' && arg.length > 0;
}

export function isNotEmptyArray(arg: unknown): arg is unknown[] {
  return arg instanceof Array && arg.length > 0;
}
